import {
  type CountExamEventReportItemSummaryQuery,
  RegistrationType,
  ExamEventReportItemSummaryType,
} from '@report/graphql';

function sumCount(
  count1: Record<RegistrationType, number>,
  count2: Record<RegistrationType, number>,
) {
  const result: Record<RegistrationType, number> = {
    [RegistrationType.Public]: 0,
    [RegistrationType.InHouse]: 0,
  };

  for (const regType of Object.values(RegistrationType)) {
    result[regType] = Number(count1?.[regType] ?? 0) + Number(count2?.[regType] ?? 0);
  }

  return result;
}

export function mapCountExamEventReportItemSummary(
  summariesCount: CountExamEventReportItemSummaryQuery['reportCountExamEventReportItemSummary']['summariesCount'],
) {
  const fallbackCount: Record<RegistrationType, number> = {
    [RegistrationType.Public]: 0,
    [RegistrationType.InHouse]: 0,
  };

  const eventCount: Record<RegistrationType, number> =
    summariesCount?.[ExamEventReportItemSummaryType.EventCount] ?? fallbackCount;
  const seatCount: Record<RegistrationType, number> =
    summariesCount?.[ExamEventReportItemSummaryType.SeatCount] ?? fallbackCount;
  const registeredExamineeCount: Record<RegistrationType, number> =
    summariesCount?.[ExamEventReportItemSummaryType.RegisteredExamineeCount] ?? fallbackCount;
  const attendedExamineeCount: Record<RegistrationType, number> =
    summariesCount?.[ExamEventReportItemSummaryType.AttendedExamineeCount] ?? fallbackCount;
  // TODO: Add separated canceled examinee count when the ui for canceled examinee is ready. For now, we will count canceled examinee as absent examinee.
  const absentExamineeCount: Record<RegistrationType, number> =
    sumCount(
      summariesCount?.[ExamEventReportItemSummaryType.AbsentExamineeCount] ?? fallbackCount,
      summariesCount?.[ExamEventReportItemSummaryType.CanceledExamineeCount] ?? fallbackCount,
    ) ?? fallbackCount;

  return {
    EVENT_COUNT: {
      ...eventCount,
      total: Object.values(eventCount).reduce((acc, curr) => acc + Number(curr), 0),
    },
    SEAT_COUNT: {
      ...seatCount,
      total: Object.values(seatCount).reduce((acc, curr) => acc + Number(curr), 0),
    },
    REGISTERED_EXAMINEE_COUNT: {
      ...registeredExamineeCount,
      total: Object.values(registeredExamineeCount).reduce((acc, curr) => acc + Number(curr), 0),
    },
    ATTENDED_EXAMINEE_COUNT: {
      ...attendedExamineeCount,
      total: Object.values(attendedExamineeCount).reduce((acc, curr) => acc + Number(curr), 0),
    },
    ABSENT_EXAMINEE_COUNT: {
      ...absentExamineeCount,
      total: Object.values(absentExamineeCount).reduce((acc, curr) => acc + Number(curr), 0),
    },
  };
}
